import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  filter31kgiqs90is7g as filter,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  Action1a4ymn5nx79hk as Action,
} from '../../../../utils/utils.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
  minus1paei8txflgx9 as minus,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { isContractorEditable2xd7urpt5jbec as isContractorEditable } from '../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../screens/common/ProjectView.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77 } from '../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { label287uhiq3m9m4z as label2 } from '../../label2.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  times2ukvaf6yk96p2 as times,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  space2ppi73m2qk1br as space,
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../space.mjs';
import { get_bold1rri6ahk98puv as get_bold } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  _Angle___init__impl__g23q1mpxbjdjfwrarw as _Angle___init__impl__g23q1m,
  Angle36m0cdko0c63j as Angle,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Angle.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../theming/separators.mjs';
import {
  get_padded3m3frjnjujncx as get_padded,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../sdk/UserSession.mjs';
import {
  isUnread2wfj6ps7oiv9h as isUnread,
  isUnread2u0ehyt0ioouz as isUnread_0,
} from '../../../../extensions/HasReadBy.ext.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { expandButtonu3usotf5fiqs as expandButton } from '../../expansion.mjs';
import { renderContractorNotes38zg0r7j0ume5 as renderContractorNotes } from '../renderContractorNotes.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../../nav/crowpay.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../files/renderFiles.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { CreateOrEditNote2axvnom01lmg9 as CreateOrEditNote } from '../../../dialogs/CreateOrEditNote.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_rotation2o00xy9g08m4u as get_rotation,
  set_rotationrdhjwh8aps06 as set_rotation,
} from '../../../../actuals/rotation.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function projectDetails(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var showNotes = Signal().fak(false);
  var tmp = _this__u8e3s4.vgv();
  var descriptionHistory = filter(tmp, projectDetails$lambda);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp_0 = get_atEnd(view);
    var tmp_1 = view.ibb(view.ibb(tmp_0, shownWhen(view, VOID, ($this$shownWhen) => isContractorEditable($this$shownWhen.baj(_this__u8e3s4.jfy()).w7b_1))), get_tertiaryButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    specCenteredText(view_0, '+ Contractor Note');
    onClick(view_0, VOID, VOID, projectDetails$slambda_0(showNotes, _this__u8e3s4));
    view.fbb(p_0, view_0);
    view.jbb(tmp_1, view_0);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.zb8(get_rem(1.5));
  label2(view_1, 'Total Value', VOID, ($this$label2) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$3 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj(_this__u8e3s4.jfy()).y7b_1);
      this_0.set(tmp$ret$3);
      return Unit_instance;
    });
    $this$label2.fbb(p, view);
    return view;
  });
  var tmp_2 = shownWhen(view_1, VOID, ($this$shownWhen) => !($this$shownWhen.baj(_this__u8e3s4.jfy()).s7b_1 == null));
  view_1.jbb(tmp_2, label2(view_1, 'Awarded', VOID, ($this$label2) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp0_safe_receiver = $this$reactiveScope.baj(_this__u8e3s4.jfy()).s7b_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q54_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : format(tmp1_safe_receiver, Formats_getInstance().k8z_1);
      var tmp$ret$10 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      this_0.set(tmp$ret$10);
      return Unit_instance;
    });
    $this$label2.fbb(p, view);
    return view;
  }));
  label2(view_1, 'Description', VOID, ($this$label2) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_1(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$17 = $this$reactiveScope.baj(_this__u8e3s4.jfy()).e7b_1;
      this_0.set(tmp$ret$17);
      return Unit_instance;
    });
    $this$label2.fbb(p, view);
    return view;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(true);
  view_2.zb8(get_AppDimensions().pg2_1);
  shownDefaultFalse(view_2, ($this$shownDefaultFalse) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownDefaultFalse.baj(descriptionHistory).i1();
  });
  var expanded = Signal().fak(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp_3 = view_2.hbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(false);
  space(view_4, minus(get_AppDimensions().wg1_1, times(get_AppDimensions().jg2_1, 2)));
  view_4.jbb(view_4.ibb(get_bold(view_4), get_centered(view_4)), body(view_4, 'Change History'));
  var tmp_4 = get_centered(view_4);
  var tmp_5 = Companion_getInstance().zcf_1;
  view_4.jbb(tmp_4, icon(view_4, tmp_5, 'Open/Close Change History', ($this$icon) => {
    var tmp = KMutableProperty0();
    var tmp_0 = _get_rotation_$ref_mwbk4($this$icon);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('rotation', 0, tmp, tmp_0, _set_rotation_$ref_g6n248($this$icon));
    reactiveScope($this$icon, ($this$reactiveScope) => {
      var tmp;
      if ($this$reactiveScope.baj(expanded)) {
        // Inline function 'com.lightningkite.kiteui.models.degrees' call
        var this_1 = -90.0;
        tmp = _Angle___init__impl__g23q1m(this_1 / 360.0);
      } else {
        // Inline function 'com.lightningkite.kiteui.models.degrees' call
        tmp = _Angle___init__impl__g23q1m(90.0 / 360.0);
      }
      var tmp$ret$28 = new (Angle())(tmp);
      this_0.set(tmp$ret$28);
      return Unit_instance;
    });
    return Unit_instance;
  }));
  onClick(view_3, VOID, VOID, projectDetails$slambda_2(expanded));
  view_3.fbb(p_4, view_4);
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_3, view_3);
  greySeparator(view_2);
  var tmp_6 = view_2.ibb(shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded)), get_padded(view_2));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Frame())(view_2.pc());
  var tmp0_elvis_lhs_5 = view_2.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
  view_2.ebb(p_5, view_5);
  view_5.eba(get_AppDimensions().wg1_1);
  view_5.zb8(get_AppDimensions().wg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.xbm(true);
  forEach(view_6, descriptionHistory, projectDetails$lambda_0);
  view_5.fbb(p_6, view_6);
  view_2.fbb(p_5, view_5);
  view_2.jbb(tmp_6, view_5);
  space(view_2, get_dp(0));
  view_1.fbb(p_2, view_2);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_7 = view_1.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
    view_1.ebb(p_7, view_7);
    view_7.xbm(true);
    var unread = remember(VOID, VOID, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(_this__u8e3s4.xgz());
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.f5p_1 == null) {
          destination.v(element);
        }
      }
      return isUnread(destination, $this$remember.baj(get_session()).efv_1);
    });
    var expandAction = Action('Toggle Expand', VOID, projectDetails$slambda_4(showNotes, unread, _this__u8e3s4));
    onRemove(view_7, () => {
      projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead_3wbeno(unread, _this__u8e3s4);
      return Unit_instance;
    });
    expandButton(view_7, showNotes, expandAction, ($this$expandButton) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$expandButton.pc());
      var tmp0_elvis_lhs = $this$expandButton.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$expandButton : tmp0_elvis_lhs;
      $this$expandButton.ebb(p, view);
      view.xbm(false);
      view.zb8(get_AppDimensions().mg2_1);
      get_centered(view);
      unreadIconWhen(view, ($this$unreadIconWhen) => $this$unreadIconWhen.baj(unread));
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
      Companion_getInstance_0();
      view.jbb(get_centered(view), bodyBold(view, 'Contractor Notes (Visible only to you)'));
      $this$expandButton.fbb(p, view);
      return Unit_instance;
    });
    var tmp_7 = shownWhen(view_7, VOID, ($this$shownWhen) => $this$shownWhen.baj(showNotes));
    // Inline function 'com.crowpay.views.components.indentIfWideCol' call
    var indent = Indent_Section_getInstance();
    var tmp_8;
    if (get_viewIsWide(view_7)) {
      // Inline function 'com.crowpay.views.components.indentedCol' call
      var tmp2 = indent.ygq_1;
      // Inline function 'com.crowpay.views.components.indentedCol' call
      var afterSpace = indent.zgq_1;
      var tmp_9 = get_unpadded(view_7);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_8 = new (Frame())(view_7.pc());
      var tmp0_elvis_lhs_8 = view_7.cbb_1;
      var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
      view_7.ebb(p_8, view_8);
      var tmp_10;
      var tmp_11 = null;
      if (!((tmp_11 == null ? null : new (Dimension())(tmp_11)) == null)) {
        tmp_10 = sizeConstraints(view_8, VOID, VOID, VOID, VOID, VOID, null);
      } else {
        tmp_10 = Companion_getInstance_0();
      }
      var tmp_12 = view_8.ibb(tmp_10, indented(view_8, tmp2, afterSpace));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_9 = new (RowOrCol())(view_8.pc());
      var tmp0_elvis_lhs_9 = view_8.cbb_1;
      var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
      view_8.ebb(p_9, view_9);
      view_9.xbm(true);
      var tmp_13 = _this__u8e3s4.xgz();
      var tmp_14 = filter(tmp_13, projectDetails$lambda_1);
      var tmp_15 = ($this$renderContractorNotes) => $this$renderContractorNotes.baj(_this__u8e3s4.jfy()).d7b_1;
      var tmp_16 = _this__u8e3s4.rgj();
      renderContractorNotes(view_9, tmp_14, tmp_15, tmp_16, () => {
        showNotes.mam(true);
        return Unit_instance;
      });
      view_8.fbb(p_9, view_9);
      view_8.jbb(tmp_12, view_9);
      view_7.fbb(p_8, view_8);
      tmp_8 = view_7.jbb(tmp_9, view_8);
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_10 = new (RowOrCol())(view_7.pc());
      var tmp0_elvis_lhs_10 = view_7.cbb_1;
      var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
      view_7.ebb(p_10, view_10);
      view_10.xbm(true);
      var tmp_17 = _this__u8e3s4.xgz();
      var tmp_18 = filter(tmp_17, projectDetails$lambda_2);
      var tmp_19 = ($this$renderContractorNotes) => $this$renderContractorNotes.baj(_this__u8e3s4.jfy()).d7b_1;
      var tmp_20 = _this__u8e3s4.rgj();
      renderContractorNotes(view_10, tmp_18, tmp_19, tmp_20, () => {
        showNotes.mam(true);
        return Unit_instance;
      });
      view_7.fbb(p_10, view_10);
      tmp_8 = view_10;
    }
    var tmp$ret$69 = tmp_8;
    view_7.jbb(tmp_7, tmp$ret$69);
    view_1.fbb(p_7, view_7);
  }
  label2(view_1, 'Project Files (Images, Bids, Plans, Specs)', VOID, ($this$label2) => renderFiles($this$label2, remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(_this__u8e3s4.jfy()).i7b_1), get_AppDimensions().qg2_1));
  view.fbb(p_1, view_1);
  writer.fbb(p, view);
  return view;
}
function projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead_3wbeno(unread, $this_projectDetails) {
  var tmp = get_AppScope();
  return launch(tmp, VOID, VOID, projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6_0(unread, $this_projectDetails));
}
function projectDetails$lambda($this$filter, it) {
  return !(it.u57_1 == null);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  $this.ygz_1.mam(true);
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zgz_1.jfy();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xgd(CreateOrEditNote().gh0(tmp$ret$0.x7a_1, null, 'Add notes, pictures, or files that are for INTERNAL team only.  (ie. client or property considerations for managers and crews.)'));
  return Unit_instance;
}
var projectDetails$slambdaClass;
function projectDetails$slambda() {
  if (projectDetails$slambdaClass === VOID) {
    class $ {
      constructor($showNotes, $this_projectDetails) {
        this.ygz_1 = $showNotes;
        this.zgz_1 = $this_projectDetails;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectDetails$slambdaClass = $;
  }
  return projectDetails$slambdaClass;
}
function projectDetails$slambda_0($showNotes, $this_projectDetails) {
  var i = new (projectDetails$slambda())($showNotes, $this_projectDetails);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function _get_rotation_$ref_mwbk4(p0) {
  return () => {
    var tmp0 = p0;
    return new (Angle())(get_rotation(tmp0));
  };
}
function _set_rotation_$ref_g6n248(p0) {
  return (_this__u8e3s4) => {
    var tmp0 = p0;
    set_rotation(tmp0, _this__u8e3s4.ycx_1);
    return Unit_instance;
  };
}
var projectDetails$slambdaClass_0;
function projectDetails$slambda_1() {
  if (projectDetails$slambdaClass_0 === VOID) {
    class $ {
      constructor($expanded) {
        this.hh0_1 = $expanded;
      }
      sao($completion) {
        this.hh0_1.mam(!this.hh0_1.f2());
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectDetails$slambdaClass_0 = $;
  }
  return projectDetails$slambdaClass_0;
}
function projectDetails$slambda_2($expanded) {
  var i = new (projectDetails$slambda_1())($expanded);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function projectDetails$lambda_0($this$forEach, historical) {
  var tmp0_elvis_lhs = historical.u57_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var description = tmp;
  var tmp1_elvis_lhs = historical.v57_1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var time = tmp_0;
  body($this$forEach, format(time, Formats_getInstance().j8z_1) + ': ' + description);
  greySeparator($this$forEach);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ih0_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    launch($this$Action, VOID, VOID, projectDetails$slambda$slambda_0($this.jh0_1, $this.kh0_1));
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ih0_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$1 = tmp_0;
  var tmp_1 = $this.ih0_1.gah(!tmp$ret$1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var projectDetails$slambda$slambdaClass;
function projectDetails$slambda$slambda() {
  if (projectDetails$slambda$slambdaClass === VOID) {
    class $ {
      constructor($unread, $this_projectDetails) {
        this.lh0_1 = $unread;
        this.mh0_1 = $this_projectDetails;
      }
      wah($this$launch, $completion) {
        projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead_3wbeno(this.lh0_1, this.mh0_1);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    projectDetails$slambda$slambdaClass = $;
  }
  return projectDetails$slambda$slambdaClass;
}
function projectDetails$slambda$slambda_0($unread, $this_projectDetails) {
  var i = new (projectDetails$slambda$slambda())($unread, $this_projectDetails);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var projectDetails$slambdaClass_1;
function projectDetails$slambda_3() {
  if (projectDetails$slambdaClass_1 === VOID) {
    class $ {
      constructor($showNotes, $unread, $this_projectDetails) {
        this.ih0_1 = $showNotes;
        this.jh0_1 = $unread;
        this.kh0_1 = $this_projectDetails;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    projectDetails$slambdaClass_1 = $;
  }
  return projectDetails$slambdaClass_1;
}
function projectDetails$slambda_4($showNotes, $unread, $this_projectDetails) {
  var i = new (projectDetails$slambda_3())($showNotes, $unread, $this_projectDetails);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function projectDetails$lambda_1($this$filter, it) {
  return it.f5p_1 == null;
}
function projectDetails$lambda_2($this$filter, it) {
  return it.f5p_1 == null;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nh0_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var session = tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.oh0_1.xgz();
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = tmp_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp_2;
      if (element.f5p_1 == null) {
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_3 = get_session();
        var tmp_3 = await_0(this_3, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var tmp$ret$3 = tmp_3;
        tmp_2 = isUnread_0(element, tmp$ret$3.efv_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        destination.v(element);
      }
    }
    var items = destination;
    var tmp_4 = session.tfw().off_1;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(items, 10));
    var _iterator__ex2g4s_0 = items.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$7 = item.d5p_1;
      destination_0.v(tmp$ret$7);
    }
    var tmp_5 = tmp_4.tf9(destination_0, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    // Inline function 'kotlin.collections.associateBy' call
    var this_4 = tmp_5;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_4, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s_1 = this_4.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      var tmp$ret$10 = element_0.d5p_1;
      destination_1.s3(tmp$ret$10, element_0);
    }
    var newItems = destination_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = get_session();
    var tmp_6 = await_0(this_5, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = tmp_6.zfv_1;
    var tmp_8 = (it) => newItems.q3().t1(it.d5p_1);
    tmp_7.ceo(tmp_8, (it) => newItems.p3(it.d5p_1));
  }
  return Unit_instance;
}
var projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6Class;
function projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6() {
  if (projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6Class === VOID) {
    class $ {
      constructor($unread, $$this_projectDetails) {
        this.nh0_1 = $unread;
        this.oh0_1 = $$this_projectDetails;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6Class = $;
  }
  return projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6Class;
}
function projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6_0($unread, $$this_projectDetails) {
  var i = new (projectDetails$_anonymous_$_anonymous_$_anonymous_$_anonymous_$markAsRead$slambda_m1hnj6())($unread, $$this_projectDetails);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  projectDetails as projectDetails3emvwwschfdk7,
};
//endregion

//# sourceMappingURL=projectDetails.mjs.map
